var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41276 8.66178L2.16276 14.9118C1.98664 15.0879 1.74777 15.1868 1.4987 15.1868C1.24962 15.1868 1.01075 15.0879 0.834634 14.9118C0.658513 14.7357 0.55957 14.4968 0.55957 14.2477C0.55957 13.9986 0.658513 13.7598 0.834634 13.5837L6.42135 7.9985L0.836197 2.41178C0.748991 2.32458 0.679815 2.22105 0.632619 2.10711C0.585424 1.99317 0.561133 1.87105 0.561133 1.74772C0.561133 1.62439 0.585424 1.50227 0.632619 1.38833C0.679815 1.27439 0.748991 1.17086 0.836197 1.08366C0.923403 0.996452 1.02693 0.927276 1.14087 0.880081C1.25481 0.832885 1.37693 0.808594 1.50026 0.808594C1.62359 0.808594 1.74571 0.832885 1.85965 0.880081C1.97359 0.927276 2.07712 0.996452 2.16432 1.08366L8.41432 7.33366C8.50162 7.42086 8.57084 7.52443 8.61803 7.63844C8.66521 7.75245 8.68942 7.87466 8.68928 7.99804C8.68913 8.12143 8.66463 8.24358 8.61718 8.35748C8.56973 8.47138 8.50026 8.57479 8.41276 8.66178Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3784373f7a5d99d1c2208fb9ba675405.svg";
export { ForwardRef as ReactComponent };